import {
  GET_CART_REQUEST,
  GET_CART_SUCCESS,
  GET_CART_FAILURE,
  GET_PRODUCTS_REQUEST,
  SELECT_NEW_PACKAGE,
} from "../../constants";
import { createAction, createErrorAction } from "../../utils";

import showError from "../showError/showError";

import {
  getChosenPackage,
  getUpsellProducts,
  getCartItems,
} from "../../selectors";

import { registerGTMEvent } from "../registerGTMEvent/registerGTMEvent";
import { getUpsellProductsAndAddonPrices } from "../getUpsellProductsAndAddonPrices/getUpsellProductsAndAddonPrices";

// Cart
const getCartRequest = createAction(GET_CART_REQUEST);
const getCartSuccess = createAction(GET_CART_SUCCESS);
const getCartFailure = createErrorAction(GET_CART_FAILURE);

// Products
const getProductsRequest = createAction(GET_PRODUCTS_REQUEST);
const getProductsSuccess = createAction(SELECT_NEW_PACKAGE);

// For some bundle products we don't want to push addToCart event for the plan
// as there are more products in the bundle (shouldPushAddToCartGTMEvent = false).
// Instead pushAddToCart should be called from the component and include
// a full list of products in a single GTM event.
export const selectPackageAndUpdate = (
  updatePackage,
  shouldPushAddToCartGTMEvent = true,
) => {
  return async (dispatch, getState, { api }) => {
    const state = getState();
    let cartData;
    const cartItems = getCartItems(state);
    const upsellProducts = getUpsellProducts(state);
    const packageInBasket = getChosenPackage(state);

    // Load requests
    dispatch(getCartRequest());
    dispatch(getProductsRequest());

    let responseData = {
      doSelectPackage: false,
      upsellProducts: [],
      addonProductPrices: {},
    };

    // Select the package on the backend
    responseData.doSelectPackage = await api.selectPackage(updatePackage);
    window.sessionStorage.setItem("ChosenPackage", updatePackage);
    window.sessionStorage.removeItem("hostingAutoAddedToCart");

    // 🤔 The only known use case is when hosting package gets removed
    // from the cart and upsell products need to update for DOMAIN_ONLY.
    // The upsell list would only ever update if the package is removed from
    // the list itself. Removing the package from the cart's bin icon won't work.
    if (upsellProducts.indexOf(updatePackage) === -1) {
      const result = await dispatch(
        getUpsellProductsAndAddonPrices(updatePackage, cartItems.length),
      );

      responseData.upsellProducts = result.upsellProducts;
      responseData.addonProductPrices = result.addonProductPrices;
      responseData.highlightedUpsell = result.highlightedUpsell;
    }

    dispatch(getProductsSuccess(responseData));

    try {
      cartData = await api.getCart();

      // if updatePackage is "DOMAIN_ONLY" it means a plan has been removed
      // from the cart. In that case no addToCart event should not be sent.
      if (window.GTM) {
        if (updatePackage !== "DOMAIN_ONLY" && shouldPushAddToCartGTMEvent) {
          dispatch(
            registerGTMEvent.addToCart({
              type: "package",
              // location: "In-cart upsell", // unused for GTM at the moment
              product: { id: updatePackage },
            }),
          );

          window.GTM.pushCartContents(cartData);
        }

        // Package removal should trigger only if one package is removed or
        // replaced with another except for upgrading from DOMAIN_ONLY.
        // Choosing a plan when there is only domain in the basket (DOMAIN_ONLY)
        // should not trigger a GTM removal.
        // DOMAIN_ONLY is not a real package but merely an indication for domain
        // without a plan.
        if (
          packageInBasket &&
          packageInBasket !== "DOMAIN_ONLY" &&
          packageInBasket !== updatePackage
        ) {
          // The previous implementation was using window.GTM.onPackageChange().
          // What it does internally is to just remove package and/or domain
          // but in a less reliable way.
          dispatch(
            registerGTMEvent.removeFromCart({
              product: packageInBasket,
              type: "package",
              index: null, // index has not been agreed upon yet
              // location: "Cart",
            }),
          );
        }
      }

      dispatch(getCartSuccess(cartData));
    } catch (err) {
      dispatch(showError("cartUpdateFailed"));
      dispatch(getCartFailure(err));
    }
  };
};
